module.exports = __webpack_public_path__ + "img/SpielohneGrenzenHeerstedt2.ef44fa44.jpg";